import React from "react";

const Loading = () => <div style={{textAlign:'center'}}>Loading ...</div>;

export default Loading